import { string, object } from 'yup';
import { c as colorCodesList } from '../../../../../constants-LkG-Sonv.js';
import { s as COLOR_REQUIRED_MESSAGE, O as OPTION_MESSAGE } from '../../../../../validation-AjMAVn7m.js';
import '../../../../../product-_pRduMz7.js';

const getInitialValues = (options) => options.reduce((acc, value) => ({
    ...acc,
    [value.attribute_code]: '',
}), {});

const validationSchema = (properties) => {
    const rules = {};
    properties.forEach(property => {
        const message = colorCodesList.includes(property)
            ? COLOR_REQUIRED_MESSAGE
            : OPTION_MESSAGE;
        rules[property] = string().required(message);
    });
    return object().shape(rules);
};

export { getInitialValues, validationSchema };
//# sourceMappingURL=index.js.map
